<template>
  <div>
    <b-row v-if="kpiCards.length" class="mb-3">
      <b-col
        v-for="c in kpiCards"
        :key="c.key"
        :md="kpiCol"
        sm="6"
        class="mb-2"
      >
        <kpi-card :label="c.label" :value="c.value" :format="c.format" />
      </b-col>
    </b-row>

    <slot name="extra" :summary="summary" :meta="meta"></slot>

    <b-card>
      <drill-table
        :title="title"
        :rows="rows"
        :busy="loading"
        :total="total"
        :page="page"
        :per-page="perPage"
        :drillable="drillable"
        :drill-path="drillPath"
        @drill="onDrill"
        @drill-pop="popDrill"
        @drill-reset="resetDrill"
        @page="setPage"
        @export="exportXlsx"
      />
    </b-card>

    <ticket-drawer
      :visible="drawer.visible"
      :sucursal-id="drawer.sucursalId"
      :ticket-id="drawer.ticketId"
      @close="closeDrawer"
    />
  </div>
</template>

<script>
import KpiCard from './KpiCard.vue';
import DrillTable from './DrillTable.vue';
import TicketDrawer from './TicketDrawer.vue';
import execReportMixin from './execReportMixin';

// Panel genérico de un reporte ejecutivo: KPIs (derivados del summary) + tabla con
// drill-down + drawer de ticket. Las pestañas nombradas (ExecSales, ExecLoyalty, …)
// lo envuelven fijando report-name y title (doc 04 §3).
export default {
  name: 'ExecReportPanel',
  components: { KpiCard, DrillTable, TicketDrawer },
  mixins: [execReportMixin],
  props: {
    reportName: { type: String, required: true },
    title: { type: String, default: 'Detalle' },
    drillable: { type: Boolean, default: true }
  },
  computed: {
    kpiCards() {
      const out = [];
      const s = this.summary || {};
      Object.keys(s).forEach((k) => {
        const v = s[k];
        if (v === null || v === undefined) return;
        if (typeof v === 'object') return;
        if (typeof v === 'boolean') return;
        out.push({ key: k, label: this.humanize(k), value: v, format: this.guessFormat(k) });
      });
      return out;
    },
    kpiCol() {
      const n = this.kpiCards.length;
      if (n <= 4) return 3;
      if (n <= 6) return 2;
      return 2;
    }
  },
  methods: {
    humanize(k) {
      return k.replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase());
    },
    guessFormat(k) {
      const key = k.toLowerCase();
      if (/(_pct|percent|rate|share|margin|growth|vs_|roi|roas)/.test(key)) return 'percent';
      if (/(sales|revenue|ticket|spend|amount|total|value|ltv|cost|shipping|consumo)/.test(key)) return 'money';
      return 'number';
    }
  }
}
</script>
